/**
 * Determines if the given number is an even number.
 */
export const isEven = (number: number): boolean => number % 2 === 0;
